// Validateurs de FORMAT partages (mail, telephone) et leurs messages.
//
// Ces regex vivaient en copie locale dans OperationFormulaireAdmin (BC). Les reutiliser depuis le
// domaine BC et MS aurait fait une 2e puis une 3e copie : deux formulaires qui refusent des valeurs
// differentes pour un meme champ, c'est le genre d'ecart qui ne se voit qu'en production.

// Volontairement permissive : elle rejette les fautes de frappe evidentes (espace, arobase manquante,
// domaine sans point) sans pretendre valider la RFC 5322, qu'aucune regex ne couvre correctement.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Numero francais a 10 chiffres. La saisie est normalisee avant test : l'utilisateur peut ecrire
// "06 78 90 12 34" ou "06.78.90.12.34", seuls les chiffres comptent.
const TELEPHONE_FR_RE = /^0[1-9]\d{8}$/;

export const isValidEmail = (value: string): boolean => EMAIL_RE.test(value.trim());

export const isValidPhoneFr = (value: string): boolean =>
  TELEPHONE_FR_RE.test(value.replace(/\D/g, ''));

export const FORMAT_ERROR_MAIL = 'Adresse mail invalide (ex : john.smith@gmail.com).';
export const FORMAT_ERROR_TELEPHONE = 'Téléphone invalide (10 chiffres, ex : 0678901234).';
